import { UPDATE_ANSWERS } from 'client/constants/actions';

type Payload = {
	cardId: string;
	answerId: string;
	votes?: {
		// answerId: percentage to total
		[key: string]: number;
	};
};
/**
 * Store selected answer ids
 */
export function updateAnswers(payload: Payload) {
	return {
		type: UPDATE_ANSWERS,
		payload,
	};
}
